// import icon from "../../../../assets/images/leftMenu/basePortal/icon_text.png"
let icon = "icon-portal-menu_text"
export default {
  name: "文本列表",
  id: "",
  type: "cxSystemText",
  componentType:"emptyLayoutComponent",
  thumbnail: icon,
  // typeId: "118786c83a85e111ed0b1e426be871943ff8",
  typeId: "",
  children: []
}
